import { FC, useEffect, useState } from "react";

import { useLocation } from "react-router-dom";

import { useAppDispatch } from "store";
import { getContracts, getContractsCategories } from "store/contracts/contracts.thunks";
import { ContractsHeader, ContractsTable, ContractsFooter } from "components/contracts";
import { useBreadcrumbs } from "context/useBreadcrumbs";
import { RouteLinks } from "services/router.service";

const ContractsPage: FC = () => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const [ selectedMonth, setSelectedMonth ] = useState<string>(() => {
    const now = new Date();
    return `${ now.getMonth() + 1 }/${ now.getFullYear() }`;
  });

  const isDocGenRoute = location.pathname === RouteLinks.PROTECTED.CONTRACTS_ROUTES.DOC_GEN;

  useEffect(() => {
    dispatch(getContracts());
    dispatch(getContractsCategories());
  }, []);

  useBreadcrumbs([
    { label: "Contracts" },
  ]);

  const handleMonthChange = (month: string) => {
    setSelectedMonth(month);
  };

  return (
    <div className="default-page-wrapper">
      <ContractsHeader isDocGenRoute={ isDocGenRoute } onMonthChange={ handleMonthChange } selectedMonth={ selectedMonth }/>
      <ContractsTable selectedMonth={ selectedMonth }/>
      <ContractsFooter/>
    </div>
  )
}

export default ContractsPage;
